import React from 'react'
import { build_img, cart_img, home_img, lock_dash_img } from '../../assets/imgs'

const MainBox = ({ list }) => {
    return (
        <div>
            <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 sec ">
                Dashboard
            </h2>
            <p className="f3 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4 primary">
                Application User
            </p>
            <div className='d-flex flex-wrap gap-4 '>
                <div className='dash-box'>
                    <div className="d-flex ac-jc">
                        <img src={build_img} alt="" />
                        <p className='f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-0 ms-2'>{list?.total_users}</p>
                    </div>
                    <h4 className='f2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mb-0 text-center mt-3'>Total Users</h4>
                </div>
                <div className='dash-box'>
                    <div className="d-flex ac-jc">
                        <img src={home_img} alt="" />
                        <p className='f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-0 ms-2'>{list?.total_customers}</p>
                    </div>
                    <h4 className='f2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mb-0 text-center mt-3'>Total Customers</h4>
                </div>
                <div className='dash-box'>
                    <div className="d-flex ac-jc">
                        <img src={lock_dash_img} alt="" />
                        <p className='f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-0 ms-2'>{list?.total_owners}</p>
                    </div>
                    <h4 className='f2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mb-0 text-center mt-3'>Total Owners</h4>
                </div>
                <div className='dash-box'>
                    <div className="d-flex ac-jc">
                        <img src={cart_img} alt="" />
                        <p className='f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-0 ms-2'>{list?.total_receptionists}</p>
                    </div>
                    <h4 className='f2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mb-0 text-center mt-3'>Total Receptionist</h4>
                </div>
            </div>
        </div>
    )
}

export default MainBox
